import { render, staticRenderFns } from "./PaginatedTable.vue?vue&type=template&id=4c17790e"
import script from "./PaginatedTable.vue?vue&type=script&lang=js"
export * from "./PaginatedTable.vue?vue&type=script&lang=js"
import style0 from "./PaginatedTable.vue?vue&type=style&index=0&id=4c17790e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports